import Vue from 'vue';
import App from './App.vue';
import VueResource from 'vue-resource';
import VueI18n from 'vue-i18n';
import Notifications from 'vue-notification';
import VModal from 'vue-js-modal';
import '@babel/polyfill';
import VueBrowserUpdate from 'vue-browserupdate';
import VueIntro from 'vue-introjs/dist/index.min';
import VueCookies from 'vue-cookies';
import "blueimp-canvas-to-blob";

Vue.use(VueResource);
Vue.use(VueI18n);

Vue.use(VModal, {
    dialog: true,
    dynamic: true,
    injectModalsContainer: true,
});

Vue.use(Notifications);

/*Browser-update configuration*/
Vue.use(VueBrowserUpdate, {
    options: {
        container: document.body,
        reminder: 0,
        nomessage: true,
        required: {
            e:10,               // Edge latest: 17
            f:56,               // Firefox latest: 63
            o:51,               // Opera latest: 70
            s:-2,               // Safari latest: 11.1
            c:"55.0.2883.75",   // Chrome latest: 70
            i: 10,              // Internet Explodierer latest: 11
            y:18.1,             // Yandex Browser
            v:"1.10",           // Vivaldi
            uc:11.5,            // UC Browser
            o_a:45,             // Opera Android
            samsung:7.0         // Samsung Internet Android
        },
    },
    // test: false,
});

Vue.use(VueIntro, {
    waitTimeout: 400,
});

Vue.use(VueCookies);
VueCookies.config('7d');

import 'intro.js/introjs.css';

const i18n = new VueI18n({
    locale: 'de',
    fallbackLocale: 'en',
    messages,
});

Vue.http.options.root = 'http://plexipeople.dev.sw.netinventors.de/custom/plugins/NetiPlexipeopleLeonardo/';

Vue.mixin({
    data: function() {
        return {
            get basePath() {
                return '/files/NetiPlexipeopleLeonardo/';
            }
        }
    }
});

new Vue({
    el: '#app',
    render: h => h(App),
    i18n,
});

Vue.browserUpdate.onshow((infos) => {
    App.methods.updateBrowserVersion(true);
});




// WEBPACK FOOTER //
// ./src/main.js